import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

import PropTypes from 'prop-types';
import { Button as Buttons } from '@telus-uds/components-web'
import ConfirmationBox from '../../design/shared/ConfirmationBox';

import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import { Button,ButtonBox } from './css';
import { orderDetailsForm } from '../../utils/constant';

const ProceedWithOrder = ({ orderData }) => {
  const { locale, categoryName, id, step, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, proceedWithOrder },
    formButtons: { confirmButtonLabel, cancelButtonLabel },
    salesRepDashboard: { confirmationToModifyTheOrder }
  } = localizedStrings;
  const history = useHistory();

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleProceedWithOrder = () => {
    const newStep = step === 1 ? 2 : step;
    history.push({
      pathname: `/${locale}/${categoryName}/${orderDetailsForm}`,
      search: `?orderId=${id}&step=${newStep}`
    });
    window.location.reload();
  };

  if (isQuoteReference) return null;

  return (
    <>
      <Button className="action-button" onClick={() => setIsModalOpen(true)}>
        {proceedWithOrder}
      </Button>
      <ConfirmationBox
        open={isModalOpen}
        hideCloseButton={!isModalOpen}
        setOpen={() => isModalOpen}
        header={confirmationDialog}
        onClose={() => setIsModalOpen(false)}
      >
        <p style={{ fontSize: '15px', padding: '8px 0' }}>{confirmationToModifyTheOrder}</p>
        <ButtonBox>
          <Buttons variant={{ priority: 'high' }} onPress={handleProceedWithOrder} >Confirm</Buttons>
          <Buttons variant={{ priority: 'low' }} onPress={() => setIsModalOpen(false)}>cancel</Buttons>
        </ButtonBox>
      </ConfirmationBox> 
    </>
  );
};

ProceedWithOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired
};

export default ProceedWithOrder;
